import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Trainings from "./components/Trainings";
import Pricing from "./components/Pricing";
import Reviews from "./components/Reviews";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Trainings />
        <Pricing />
        <Reviews />
      </main>
      <Footer />
    </div>
  );
}

export default App;
